// extracted by mini-css-extract-plugin
export default {"Root":"top-players_Root__XCZ0n","WithImage":"top-players_WithImage__mUn8a"};